module.exports = __webpack_public_path__ + "img/cursor-text.b4d3053f.svg";